import React, {useState} from "react";
import Modal from "react-modal";
 import LiquidityBableChart from "./LiquidityBableChart";
const WithdrawStakingModal = ({ modalIsOpen, closeModal }) => {
  const [activeTab, setActiveTab] = useState('tab1');
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };



  return (
  <>
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel="Modal">
      <div className="My__Overlay">
        <div className="My__OverlayIn p-0">
          <div className="PTGCSEC popupcenter ">
            <button className="nobg closepopup d-flex align-items-center gap-1" onClick={closeModal}><span className="underline">Close</span> <img src="./images/XCircle.svg" className="img-fluid" /></button>
              
              <div className="text-center"><h2 className="mb-0 mt-3  w-100 good_times goldFont">PTGC Liquidity</h2></div>
              <div className="managePollHeight"> <LiquidityBableChart width={1200} height={800}/></div>

            </div>
        {/*<div className="statsALL mt-4">
          <div className="row">
            <div className="col-lg-6 ">
              <div className="subcontent subPad SRTOP p-0">
                <div className="snpool ">
                  <div className="relative">
                    <div className="d-flex justify-content-between snPortal">
                      <h2 className="d-flex align-items-center mb-0">
                        <span className="d-flex bothCoins">
                          <img
                            className="img-fluid"
                            src="./images/ptgccircle.svg"
                          />
                          <img className="img-fluid" src="./images/PLS.png" />
                        </span>
                        PTGC / WPLS
                      </h2>
                      <div className="iconSR">
                        <img className="img-fluid" src="./images/Coins.svg" />
                      </div>
                    </div>
                    <div className="snPortal">
                      <div className="row justify-content-between">
                        <div className="col-xl-6">
                          <div className="mb-3">
                            <span className="perVal d-block">PTGC:</span>
                            <h3 className="dollorValue value w-100 mt-0 p-0">
                              <span className="val ">51,030,696,759.46</span>
                            </h3>
                          </div>
                        </div>
                        <div className="col-xl-6">
                          <div className="mb-3">
                            <span className="perVal d-block">WPLS:</span>
                            <h3 className="dollorValue value w-100 mt-0 p-0">
                              <span className="val f34">51,030,696,759.46</span>
                            </h3>
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <div className="mb-3">
                            <span className="fInter">Total:</span>
                            <h3 className="dollorValue value mt-0">
                              <span className="dollor">$</span>
                              <span className="val f34">4,217,909.11</span>
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 ">
              <div className="subcontent subPad SRTOP p-0">
                <div className="snpool ">
                  <div className="relative">
                    <div className="d-flex justify-content-between snPortal">
                      <h2 className="d-flex align-items-center mb-0">
                        <span className="d-flex bothCoins">
                          <img
                            className="img-fluid"
                            src="./images/ptgccircle.svg"
                          />
                          <img className="img-fluid" src="./images/PLS.png" />
                        </span>
                        PTGC / WPLS
                      </h2>
                      <div className="iconSR">
                        <img className="img-fluid" src="./images/Coins.svg" />
                      </div>
                    </div>
                    <div className="snPortal">
                      <div className="row justify-content-between">
                        <div className="col-xl-6">
                          <div className="mb-3">
                            <span className="perVal d-block">PTGC:</span>
                            <h3 className="dollorValue value w-100 mt-0 p-0">
                              <span className="val f34">51,030,696,759.46</span>
                            </h3>
                          </div>
                        </div>
                        <div className="col-xl-6">
                          <div className="mb-3">
                            <span className="perVal d-block">WPLS:</span>
                            <h3 className="dollorValue value w-100 mt-0 p-0">
                              <span className="val f34">51,030,696,759.46</span>
                            </h3>
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <div className="mb-3">
                            <span className="fInter">Total:</span>
                            <h3 className="dollorValue value mt-0">
                              <span className="dollor">$</span>
                              <span className="val f34">4,217,909.11</span>
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 ">
              <div className="subcontent subPad SRTOP p-0">
                <div className="snpool ">
                  <div className="relative">
                    <div className="d-flex justify-content-between snPortal">
                      <h2 className="d-flex align-items-center mb-0">
                        <span className="d-flex bothCoins">
                          <img
                            className="img-fluid"
                            src="./images/ptgccircle.svg"
                          />
                          <img className="img-fluid" src="./images/PLS.png" />
                        </span>
                        PTGC / WPLS
                      </h2>
                      <div className="iconSR">
                        <img className="img-fluid" src="./images/Coins.svg" />
                      </div>
                    </div>
                    <div className="snPortal">
                      <div className="row justify-content-between">
                        <div className="col-xl-6">
                          <div className="mb-3">
                            <span className="perVal d-block">PTGC:</span>
                            <h3 className="dollorValue value w-100 mt-0 p-0">
                              <span className="val f34">51,030,696,759.46</span>
                            </h3>
                          </div>
                        </div>
                        <div className="col-xl-6">
                          <div className="mb-3">
                            <span className="perVal d-block">WPLS:</span>
                            <h3 className="dollorValue value w-100 mt-0 p-0">
                              <span className="val f34">51,030,696,759.46</span>
                            </h3>
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <div className="mb-3">
                            <span className="fInter">Total:</span>
                            <h3 className="dollorValue value mt-0">
                              <span className="dollor">$</span>
                              <span className="val f34">4,217,909.11</span>
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 ">
              <div className="subcontent subPad SRTOP p-0">
                <div className="snpool ">
                  <div className="relative">
                    <div className="d-flex justify-content-between snPortal">
                      <h2 className="d-flex align-items-center mb-0">
                        <span className="d-flex bothCoins">
                          <img
                            className="img-fluid"
                            src="./images/ptgccircle.svg"
                          />
                          <img className="img-fluid" src="./images/PLS.png" />
                        </span>
                        PTGC / WPLS
                      </h2>
                      <div className="iconSR">
                        <img className="img-fluid" src="./images/Coins.svg" />
                      </div>
                    </div>
                    <div className="snPortal">
                      <div className="row justify-content-between">
                        <div className="col-xl-6">
                          <div className="mb-3">
                            <span className="perVal d-block">PTGC:</span>
                            <h3 className="dollorValue value w-100 mt-0 p-0">
                              <span className="val f34">51,030,696,759.46</span>
                            </h3>
                          </div>
                        </div>
                        <div className="col-xl-6">
                          <div className="mb-3">
                            <span className="perVal d-block">WPLS:</span>
                            <h3 className="dollorValue value w-100 mt-0 p-0">
                              <span className="val f34">51,030,696,759.46</span>
                            </h3>
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <div className="mb-3">
                            <span className="fInter">Total:</span>
                            <h3 className="dollorValue value mt-0">
                              <span className="dollor">$</span>
                              <span className="val f34">4,217,909.11</span>
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>*/}
        </div>
      </div>
    </Modal>
    </>
  );
};

export default WithdrawStakingModal;